export default __webpack_public_path__ + "static/media/130.b995a636.jpg";